






























import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem';
import { mapGetters } from 'vuex';
import { pick } from 'lodash';
import { errorToMessage } from '@/core/utils/errors';

export default {
  name: 'CommunityGroupDescription',
  components: {
    TopNav,
    NavItem,
  },
  data() {
    return {
      form: {},
      inProgress: false,
      isLoading: false,
      group: null,
    };
  },
  methods: {
    toForm(communityGroup: CommunityGroupsResponse) {
      const form = pick(communityGroup, ['about_text']);
      return form;
    },
    async saveDescription() {
      try {
        this.inProgress = true;
        await this.$store.dispatch('community/editGroupDescription', {
          id: this.$route.params.group_id,
          about_text: this.form?.about_text,
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.GROUP_WAS_SUCCESSFULLY_UPDATED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.inProgress = false;
      }
    },
    setForm() {
      this.form = this.toForm(this.group);
    },
  },
  created() {
    this.setForm();
  },
  async mounted() {
    try {
      this.isLoading = true;
      this.group = await this.$store.dispatch('community/loadGroup', {
        id: this.$route.params.group_id,
      });
      this.setForm();
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
        text: errorToMessage(error?.response, `Request failed: ${error}`),
        duration: -1,
      });
    } finally {
      this.isLoading = false;
    }
  },
};
